export const CARD_IDS_BY_TYPE = {
  Overview: [
    "historic_metrics_contactSuccessOverview",
    "session_metrics_callDurationOverview",
    "historic_metrics_overallCallConnectivityOverview",
    "historic_metrics_contactConnectivityOverview",
    "session_metrics_overallResponseLatencyOverview",
    "session_metrics_voiceMailOverview",
  ],
  AHT: [
    "session_metrics_callDurationOverview",
    "session_metrics_maxCallTimeoutOverview",
    // "historic_metrics_overallCallConnectivityOverview",
    "historic_metrics_contactSuccessOverview",
    "session_metrics_voiceMailOverview",
    "session_metrics_overallResponseLatencyOverview",
  ],
  Latency: [
    "session_metrics_overallResponseLatencyOverview",
    "session_metrics_totalComponentLatencyOverview",
    "session_metrics_systemLatencyOverview",
    "session_metrics_componentLatencyPercentageOverview",
    //
    "session_metrics_brainLatencyOverview",
    "session_metrics_llmLatencyOverview",
    "session_metrics_synthesizerLatencyOverview",
    "session_metrics_ttsLatencyOverview",
//    "session_metrics_callDurationOverview",
//    "historic_metrics_overallCallConnectivityOverview",
//    "historic_metrics_contactSuccessOverview",
  ],
  Connectivity: [
    "historic_metrics_overallCallConnectivityOverview",
    "historic_metrics_primaryCallConnectivityOverview",
    "historic_metrics_redialCallConnectivityOverview",
    "historic_metrics_contactConnectivityOverview",
    "historic_metrics_contactSuccessOverview",
  ],
  Disposition: [
    "historic_metrics_redialCallConnectivityOverview",
    "historic_metrics_contactConnectivityOverview",
    "historic_metrics_contactSuccessOverview",
    "session_metrics_callDurationOverview",
  ],
  UsageBilling: [],
}

export const GRAPH_IDS_BY_TYPE = {
  // half width graphs
  Overview: [
    "session_metrics_callDurationDistribution",
    "historic_metrics_callDispositionBreakdown",
    "historic_metrics_performanceOverview",
    "historic_metrics_contactPerformanceFunnel",
    "session_metrics_overallResponseLatencyDistribution",
    "historic_metrics_callAttemptsFunnel",
  ],
  AHT: [
    "session_metrics_callDurationTimeSeries",
    "session_metrics_callDurationDistribution",
    "session_metrics_overAllResponseLatencyTimeSeries",
    "historic_metrics_callDispositionBreakdown",
  ],
  Latency: [
    "session_metrics_allComponentAverageComparisonTimeSeries",
    "session_metrics_overallResponseLatencyDistribution",
    "session_metrics_totalComponentLatencyDistribution",
    "session_metrics_overAllResponseLatencyTimeSeries",
    "session_metrics_totalComponentLatencyTimeSeries",
    "session_metrics_brainLatencyTimeSeries",
    "session_metrics_llmLatencyTimeSeries",
    "session_metrics_synthesizerLatencyTimeSeries",
    "session_metrics_ttsLatencyTimeSeries",
    "session_metrics_systemLatencyTimeSeries",
    // "session_metrics_callDurationTimeSeries"
  ],
  Connectivity: [
    "historic_metrics_callMetricsTimeSeries",
    "historic_metrics_connectivityTimeSeries",
    "historic_metrics_contactSuccessTimeSeries",
    "historic_metrics_callAttemptsFunnel",
  ],
  Disposition: [
    "historic_metrics_callDispositionTimeSeries",
    "historic_metrics_callDurationDispositionHeatmap",
    "historic_metrics_callMetricsTimeSeries",
    "historic_metrics_callDispositionBreakdown",
    "historic_metrics_contactSuccessTimeSeries",
  ],
  UsageBilling: [],
}

export const FULL_WIDTH_GRAPH_IDS_BY_TYPE = {
  Overview: [
    // "historic_metrics_connectivityTimeSeries"
  ],
  AHT: [
    // "session_metrics_overAllResponseLatencyTimeSeries",
  ],
  Latency: [
    "session_metrics_allComponentAverageComparisonTimeSeries",
  ],
  Connectivity: [
    //"historic_metrics_connectivityTimeSeries",
  ],
  Disposition: [
//    "historic_metrics_callDispositionTimeSeries",
//    "historic_metrics_callMetricsTimeSeries",
  ],
  UsageBilling: [],
}

export const TABLE_IDS_BY_TYPE = {}

export const FULL_WIDTH_TABLE_IDS_BY_TYPE = {}

export const QUICK_RANGES = [
  { label: "Today", value: "today" },
  { label: "This week", value: "week" },
  { label: "Last 15 minutes", value: "15m" },
  { label: "Last 30 minutes", value: "30m" },
  { label: "Last 1 hour", value: "1h" },
  { label: "Last 2 hours", value: "2h" },
  { label: "Last 3 hours", value: "3h" },
  { label: "Last 6 hours", value: "6h" },
  { label: "Last 12 hours", value: "12h" },
  { label: "Last 24 hours", value: "24h" },
  { label: "Last 7 days", value: "7d" },
]
